import { FC } from 'react';

import UniversalLink from '../UniversalLink';
import styles from './BreadcrumbElement.module.scss';

export type BreadcrumbElementProps = {
  children: React.ReactNode;
  path: string;
  renderLink: boolean;
};

const BreadcrumbElement: FC<BreadcrumbElementProps> = ({
  children,
  path,
  renderLink,
}) => (renderLink ? (
  <UniversalLink
    href={path}
    className={styles.root}
  >
    {children}
  </UniversalLink>
) : (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>{children}</>
));

export default BreadcrumbElement;
